import axios from "axios";
import { errorHandler } from "./errorHandler";
import { trimObjectStrings } from "./trimObjectStrings";
import { triggerLogout } from "./authService";

const apiClient = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
});

apiClient.interceptors.request.use((config) => {
	const token = localStorage.getItem("authToken");
	if (token) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	if (config.data && !(config.data instanceof FormData)) {
		config.data = trimObjectStrings(config.data);
	}
	if (config.params) {
		config.params = trimObjectStrings(config.params);
	}
	return config;
});

apiClient.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response?.status === 401) {
			triggerLogout();
		}
		const message =
			error.response?.data?.message ||
			"Unexpected error. Please try again.";
		errorHandler(message);
		return Promise.reject(new Error(message));
	}
);

export default apiClient;
